export const TYPE_LANDING_OPERATION = 'operacion';



// WEBPACK FOOTER //
// ./src/authentication/components/LandingTelmex/const.js